module.exports = __webpack_public_path__ + "static/media/Trash.cecd18af.svg";